/* Camelita · conocimiento de la tienda D'Todo Camelot (C2).
   Se carga antes de cam-camelita.js. El motor de conversación (copia de Toñito) le pregunta primero a este archivo:
   window.CamelitaTienda.antes(mensaje, herramientas) → {listo:true} si ya respondió, {mensaje} para reescribir, o null.
   Aquí va solo lo propio de Camelot: tiras Prodigy (se venden por bote de 50, con o sin lancetas),
   glucómetro y preguntas de «qué trae / qué incluye». Los precios siempre salen del motor de Samita. */
(function(){
"use strict";
var TIRAS={solo:'tiras-reactivas-glucometro-prodigy-solo-tiras',con:'tiras-reactivas-glucometro'};
var GLUCOMETRO='glucometro-prodigy-kit-para-el-monitoreo-de-la-glucosa';
var POR_BOTE=50;
var NUMS={un:1,una:1,uno:1,dos:2,tres:3,cuatro:4,cinco:5,seis:6,siete:7,ocho:8,nueve:9,diez:10};

function num(t){if(t==null)return null;if(/^\d+$/.test(t))return Number(t);return NUMS[t]||null;}

// Descripción del producto en texto (Shopify la guarda en HTML).
var descCache={};
async function descripcion(handle){
  if(descCache[handle]!=null)return descCache[handle];
  var t='';
  try{var r=await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'});
    if(r.ok){var p=await r.json();var d=document.createElement('div');d.innerHTML=p.description||'';t=(d.textContent||'').replace(/\s+/g,' ').trim();}}catch(e){}
  descCache[handle]=t;return t;
}
// «Contenido: …» o «Incluye: …» de la descripción; si no hay, el inicio.
function queIncluye(texto){
  var m=texto.match(/(?:contenido|incluye|el kit incluye|trae)\s*:\s*([^]*?)(?:\.\s+[A-ZÁÉÍÓÚ][^.]{0,40}:|\.\s*$|$)/i);
  if(m&&m[1].length>10)return m[1].replace(/\s*;\s*/g,', ').trim();
  return '';
}
function resumen(texto,max){texto=texto||'';if(texto.length<=max)return texto;var c=texto.slice(0,max);var i=c.lastIndexOf('. ');return (i>max*0.5?c.slice(0,i+1):c.replace(/\s+\S*$/,'')+'…');}

async function precioBotes(h,info,botes){
  var v=info.product.variants[0];
  var q=await h.cotizarLineas([{productId:info.product.id,variantId:v.id,handle:info.product.handle,collections:info.collections,title:info.product.title,qty:botes,unitBase:v.price/100}]);
  return q.lineas[0]?q.lineas[0].total:Math.round(v.price*botes)/100;
}

/* ---------- Tiras Prodigy ---------- */
function leerTiras(n){
  // «300 + 300» (como en el arte de la tienda) = 300 tiras con 300 lancetas.
  if((!/\btiras?\b|\bprodigy\b/.test(n)&&!/^(?:quiero\s+|necesito\s+|dame\s+)?\d{2,3}\s*\+\s*\d{2,3}$/.test(n))||/\b(dulce|acid|frutal|sour)/.test(n))return null;
  var tipo=null;
  if(/\bsin\s+(?:las\s+)?lancetas?|\bsolo\s+(?:las\s+)?tiras|\btiras\s+solas|\bnada\s+mas\s+(?:las\s+)?tiras|\bsolas\b/.test(n))tipo='solo';
  else if(/lancetas?|\d+\s*\+\s*\d+/.test(n))tipo='con';
  var botes=null,tiras=null,m;
  if((m=n.match(/(\d{1,4}|un|una|uno|dos|tres|cuatro|cinco|seis|siete|ocho|nueve|diez)\s*(?:botes?|frascos?|viales?|potes?)\b/)))botes=num(m[1]);
  else if((m=n.match(/(\d{1,4})\s*(?:\+\s*\d{1,4}\s*)?(?:tiras?\b|\+)/))||(m=n.match(/(\d{1,4})\s*(?:de\s+)?(?:las\s+)?(?:tiras?|prodigy)\b/))){var k=Number(m[1]);if(k>=POR_BOTE){tiras=k;botes=Math.ceil(k/POR_BOTE);}else botes=k;}
  else if((m=n.match(/\b(un|una|dos|tres|cuatro|cinco|seis)\s+(?:de\s+)?tiras?\b/)))botes=num(m[1]);
  return {tipo:tipo,botes:botes,tiras:tiras};
}
async function tablaTiras(h,tipos,maxBotes){
  var infos={};for(var i=0;i<tipos.length;i++)infos[tipos[i]]=await h.productInfo(TIRAS[tipos[i]]);
  var filas=[];
  for(var b=1;b<=maxBotes;b++){
    var partes=[];
    for(var j=0;j<tipos.length;j++){var t=tipos[j];partes.push((tipos.length>1?(t==='solo'?'solo tiras ':'con lancetas '):'')+h.formatted(await precioBotes(h,infos[t],b)));}
    filas.push((b*POR_BOTE)+' tiras ('+b+(b>1?' botes':' bote')+'): '+partes.join(' · '));
  }
  return {infos:infos,texto:filas.join('\n')};
}
async function atenderTiras(d,h){
  if(d.tipo&&d.botes){
    var info=await h.productInfo(TIRAS[d.tipo]),v=info.product.variants[0];
    if(!v.available){h.bot('«'+info.product.title+'» no está disponible en línea ahorita. Te paso por WhatsApp para confirmarte existencias.',{actions:[{label:'Abrir WhatsApp',primary:true,fn:async function(){h.whatsapp('Tiras Prodigy: '+d.botes*POR_BOTE+' '+(d.tipo==='con'?'con lancetas':'solo tiras'));}}]});return;}
    // Cada bote trae 50 tiras; con lancetas, trae también 50 lancetas (misma cantidad de tiras que de lancetas).
    var n=d.botes*POR_BOTE,lab=n+' tiras'+(d.tipo==='con'?' + '+n+' lancetas':''),bts=d.botes+(d.botes>1?' botes':' bote')+' de '+POR_BOTE;
    var aviso=d.tiras&&d.tiras%POR_BOTE?'Las tiras vienen en botes de '+POR_BOTE+': para '+d.tiras+' tiras te sirven '+bts+' ('+lab+').':lab+' = '+bts+(d.tipo==='con'?' (cada bote trae 50 tiras y 50 lancetas).':'.');
    h.bot(aviso,{efimero:true});
    await h.proponer([{info:info,variante:v,qty:d.botes}]);return;
  }
  if(d.botes&&!d.tipo){
    var t=await tablaTiras(h,['solo','con'],0);var ps={};
    for(var k in t.infos)ps[k]=await precioBotes(h,t.infos[k],d.botes);
    h.bot((d.botes*POR_BOTE)+' tiras Prodigy ('+d.botes+(d.botes>1?' botes':' bote')+' de '+POR_BOTE+'):\n• Solo tiras: '+h.formatted(ps.solo)+'\n• Tiras + lancetas ('+d.botes*POR_BOTE+' tiras y '+d.botes*POR_BOTE+' lancetas): '+h.formatted(ps.con)+'\n¿Cuál querés?',{actions:[
      {label:'Solo tiras · '+h.formatted(ps.solo),primary:true,say:'Solo tiras',fn:function(){return atenderTiras({tipo:'solo',botes:d.botes,tiras:d.tiras},h);}},
      {label:'Con lancetas · '+h.formatted(ps.con),say:'Con lancetas',fn:function(){return atenderTiras({tipo:'con',botes:d.botes,tiras:d.tiras},h);}}]});
    return;
  }
  var tipos=d.tipo?[d.tipo]:['solo','con'],tabla=await tablaTiras(h,tipos,6);
  var opciones=[1,2,3,4,6].map(function(b){return {label:(b*POR_BOTE)+' tiras',say:(b*POR_BOTE)+' tiras',fn:function(){return atenderTiras({tipo:d.tipo,botes:b,tiras:b*POR_BOTE},h);}};});
  h.bot('Tiras reactivas Prodigy (sin codificación), en botes de '+POR_BOTE+'. Entre más llevás, mejor precio:\n'+tabla.texto+(d.tipo==='con'?'\nCada bote trae 50 tiras y 50 lancetas.':d.tipo?'':'\nVienen solas o con lancetas (con lancetas, cada bote trae 50 tiras y 50 lancetas).')+'\n¿Cuántas tiras necesitás?',{actions:opciones});
}

/* ---------- Glucómetro Prodigy ---------- */
async function atenderGlucometro(n,h){
  var info=await h.productInfo(GLUCOMETRO),v=info.product.variants[0],txt=await descripcion(GLUCOMETRO);
  var inc=queIncluye(txt);
  var msg='Kit glucómetro Prodigy: '+h.money(v.price)+(inc?'.\nIncluye: '+inc+'.':'.');
  if(!v.available){h.bot(msg+'\nAhorita aparece agotado en la tienda en línea. Te paso por WhatsApp para confirmarte si hay y apartártelo.',{actions:[{label:'Abrir WhatsApp',primary:true,fn:async function(){h.whatsapp('Kit glucómetro Prodigy '+h.money(v.price));}},{label:'Ver tiras Prodigy',fn:function(){return atenderTiras({tipo:null,botes:null,tiras:null},h);}}]});return;}
  var m=n.match(/\b(\d{1,2})\s*(?:glucometr|kits?)/),q=m?Number(m[1]):1;
  h.bot(msg,{efimero:true});
  await h.proponer([{info:info,variante:v,qty:q}]);
}

/* ---------- «¿Qué trae / qué incluye / para qué sirve…?» de cualquier producto ---------- */
var PREGUNTA=/^(?:y\s+)?(?:que|cual(?:es)?)\s+(?:trae|traen|incluye|incluyen|lleva|llevan|contiene|contienen|viene|vienen|es|son|beneficios tiene)\s+(?:con\s+|en\s+)?(.+)$|^para\s+que\s+(?:sirve|sirven|es)\s+(.+)$|^(?:info(?:rmacion)?|detalles?|descripcion)\s+(?:de|del|sobre)\s+(.+)$/;
async function atenderPregunta(ref,h){
  ref=ref.replace(/^(?:el|la|los|las|un|una|ese|esa|este|esta)\s+/,'').trim();if(ref.length<3)return false;
  var ps=[];try{ps=await h.buscar(ref);}catch(e){return false;}
  if(!ps.length)return false;
  var p=ps[0],txt=await descripcion(p.handle);
  var info=await h.productInfo(p.handle),v=info.product.variants.find(function(x){return x.available;})||info.product.variants[0];
  var inc=queIncluye(txt),cuerpo=inc?'Incluye: '+inc+'.':(txt?resumen(txt,420):'No tengo la descripción de este producto; te puedo pasar con una persona para que te explique.');
  var acciones=[{label:'Ver producto',fn:async function(){h.irA((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'products/'+p.handle);}}];
  if(v&&v.available)acciones.unshift({label:'Agregar 1 al carrito',primary:true,say:'Agregar al carrito',fn:function(){return h.proponer([{info:info,variante:v,qty:1}]);}});
  else acciones.unshift({label:'Preguntar por WhatsApp',primary:true,fn:async function(){h.whatsapp('Consulta: '+p.title);}});
  h.bot('«'+p.title+'» · '+h.money(v.price)+(v&&v.available?'':' (agotado en línea)')+'\n'+cuerpo,{actions:acciones});
  return true;
}

window.CamelitaTienda={version:'C2',antes:async function(mensaje,h){
  var n=h.normalize(mensaje).replace(/[¿¡?!.,;:]/g,' ').replace(/\s+/g,' ').trim();
  var nSin=n.replace(/^(?:hola|buenas|buenos dias|buenas tardes|buenas noches|disculpe|oiga|camelita)\s+/,'');
  // «tiras para mi glucómetro» son tiras; «glucómetro» solo es el kit.
  if(/glucometr/.test(nSin)&&!/\btiras?\b|lancetas?/.test(nSin)){await atenderGlucometro(nSin,h);return {listo:true};}
  var t=leerTiras(nSin);if(t){await atenderTiras(t,h);return {listo:true};}
  var m=nSin.match(PREGUNTA);if(m){var ok=await atenderPregunta(m[1]||m[2]||m[3]||'',h);if(ok)return {listo:true};}
  return null;
}};
})();
